// @ts-nocheck
import {Column} from 'react-table'
import {UserCustomHeader} from '../apps/user-management/users-list/table/columns/UserCustomHeader'
import {StockValuationRecord} from './api'

const getStockValuationColumns = (): ReadonlyArray<Column<StockValuationRecord>> => [
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='Warehouse'
        className='min-w-150px ps-4 text-center'
      />
    ),
    id: 'warehouseName',
    accessor: 'warehouseName',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Product' className='min-w-150px text-center' />
    ),
    accessor: 'productName',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='SKU Code' className='min-w-125px text-center' />
    ),
    accessor: 'skuCode',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Quantity' className='min-w-100px text-center' />
    ),
    accessor: 'quantity',
    sortType: 'basic',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Unit Cost' className='min-w-125px text-center' />
    ),
    accessor: 'unitCost',
    sortType: 'basic',
    Cell: ({...props}) => <div>&#8377; {props.data[props.row.index].unitCost}</div>,
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='Total Value'
        className='min-w-125px text-center'
      />
    ),
    accessor: 'totalValue',
    sortType: 'basic',
    Cell: ({...props}) => (
      <span className='text-primary fw-bold'>&#8377; {props.data[props.row.index].totalValue}</span>
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='UOM' className='min-w-100px text-center' />
    ),
    accessor: 'unit',
    sortType: 'string',
    Cell: ({...props}) => (
      <span className='badge badge-light-dark fw-bold'>{props.data[props.row.index].unit}</span>
    ),
  },
]

export {getStockValuationColumns}
